<template lang="pug">
  div
    .subheading Nova conta
    v-form
      v-text-field(v-model='user.name' light prepend-icon='person' label='Nome')
      v-text-field(v-model='user.email' light prepend-icon='email' label='Email' type='email')
      v-text-field(v-model='user.password' light prepend-icon='lock' label='Senha' type='password')
      v-btn(block color='primary' type='submit') Criar
</template>

<script>
export default {
  data() {
    return {
      user: {}
    }
  }
}
</script>
